export default __webpack_public_path__ + "locales/pt-BR/Errors.json?hash=ea3b0d22b29c5e75d5b0be7ed692f79f";